import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useCurrentUser } from "../auth/useCurrentUser";
import { useCurrentOrgId } from "../auth/useCurrentOrgId";

/**
 * Returns whether the current user has calendar sync enabled.
 * Checks memberships.calendar_sharing_verified (Google Calendar shared with service account).
 */
export function useCalendarEnabled() {
  const { user } = useCurrentUser();
  const { orgId } = useCurrentOrgId();

  const { data, isLoading } = useQuery({
    queryKey: ["calendar-enabled", user?.user_id, orgId],
    queryFn: async () => {
      if (!user?.user_id || !orgId) return null;

      const { data: membership } = await supabase
        .from("memberships")
        .select("calendar_sharing_verified, google_calendar_id")
        .eq("user_id", user.user_id)
        .eq("org_id", orgId)
        .single();

      return membership;
    },
    enabled: !!user?.user_id && !!orgId,
  });

  return {
    calendarEnabled: !!(data as any)?.calendar_sharing_verified,
    calendarAccountId: null,
    primaryCalendarId: (data as any)?.google_calendar_id ?? null,
    loading: isLoading,
  };
}
